module.exports = __webpack_public_path__ + "static/media/MELT.11a1bb35.png";